// extracted by mini-css-extract-plugin
module.exports = {"root":"Menu_root__1ROjC","sidePanel":"Menu_sidePanel__3tZm1","mainPanel":"Menu_mainPanel__CNJc1","closeButtonContainer":"Menu_closeButtonContainer__P7AhS"};